import React, { useState } from "react";
import Select from "react-select";

const RequestReasonsSelect = (props) => {
  const reasons = [
    { value: "replacement", label: "Reemplazo" },
    { value: "fix_term", label: "Plazo Fijo" },
    { value: "new_vacancy", label: "Nueva Vacante" },
    { value: "practical", label: "Práctica" },
    { value: "other", label: "Otros" }
  ];

  const [requestReason] = useState(reasons);

  const handleChangeReason = inputValue => {
    props.handleChange(inputValue, "requestReason");
  };

  return (
    <Select
      inputId="requestReason"
      onChange={handleChangeReason}
      options={requestReason}
      placeholder="Seleccione una opción"
      value={requestReason.find(
        (option) => option.value === props.value?.value
      ) || null}
    />
  );
};

export default RequestReasonsSelect;
